module.exports = __webpack_public_path__ + "static/media/confederaziun-svizra.5941d9da.png";